import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import get from 'lodash/get';

import { Link } from 'formlabs-web-components/Link';
import { Icon } from 'formlabs-web-components/Type';

import CountryContext from '../../context/country';
import FlyOutModal from '../modal/FlyOutModal';
import Cart from './Cart';

import './MenuButton.module.css';
import { InteractiveDiv } from 'formlabs-web-components/Wrapper';

const StoreButton = props => {
  const Button = ({ storePage, t, hasItems, itemCount, color }) => (
    <Link to={storePage} styleName="button">
      <span styleName="label">{t('Store')}</span>
    </Link>
  );

  const checkoutPage = `${process.env.RAZZLE_MAGENTO_URL}/${
    props.storeId
  }/checkout/cart?cartId=${props.cartId}`;

  if (!props.hasItems) {
    return (
      <Fragment>
        <div styleName="cart-alignment">
          <Link to={checkoutPage}>
            <span styleName="cart-icon-desktop">
              <Icon
                iconName="shopping_cart"
                color={props.color}
                fontSize="1.5rem"
                v2
              />
            </span>
          </Link>
          {!props.hideButton && (
            <div styleName="menu">
              <Button {...props} />
            </div>
          )}
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Link to={checkoutPage}>
        <div styleName="cart-alignment">
          <span styleName="cart-icon-desktop">
            <FlyOutModal
              modalWidth={340}
              modalContent={<Cart />}
              id="Cart"
              clickTarget={checkoutPage}
            >
              <Icon
                iconName="shopping_cart"
                color={props.color}
                fontSize="1.5rem"
                v2
              />
              <span styleName="badge badge-mobile">{props.itemCount}</span>
            </FlyOutModal>
          </span>
          {!props.hideButton && (
            <div styleName="menu">
              <Button {...props} />
            </div>
          )}
        </div>
      </Link>
    </Fragment>
  );
};

class MenuButton extends Component {
  static contextType = CountryContext;

  state = {
    showCart: false
  };

  handleCartOpen = event => {
    if (this.props.openCart) {
      this.props.openCart();
    }
    this.setState({ showCart: true });
  };

  handleCartClose = event => {
    if (this.props.closeCart) {
      this.props.closeCart();
    }
    this.setState({ showCart: false });
  };

  render() {
    const {
      cartId,
      storeId,
      items,
      t,
      mobile,
      color,
      isExternalCartOpen,
      hideButton
    } = this.props;
    const { storePage } = this.context;
    const itemCount = items.length;
    const hasItems = itemCount > 0;

    if (mobile) {
      const CartIcon = () => (
        <Icon iconName="shopping_cart" color={color} fontSize="1.8rem" v2 />
      );

      return (
        <div styleName="mobile">
          {hasItems ? (
            <InteractiveDiv
              handler={
                isExternalCartOpen ? this.handleCartClose : this.handleCartOpen
              }
            >
              <CartIcon />
              <span styleName="badge badge-mobile">{itemCount}</span>
            </InteractiveDiv>
          ) : (
            <Link to={storePage}>
              <CartIcon />
            </Link>
          )}
        </div>
      );
    }

    return (
      <StoreButton
        storePage={storePage}
        t={t}
        cartId={cartId}
        storeId={storeId}
        hasItems={hasItems}
        itemCount={itemCount}
        color={color}
        hideButton={hideButton}
      />
    );
  }
}

export default compose(
  connect(state => {
    return {
      items: get(state, 'cart.totals.items', []),
      storeId: get(state, 'store.id'),
      cartId: get(state, 'cart.id')
    };
  }),
  withTranslation()
)(MenuButton);
